var _g, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFolderSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.1,
    height: 20.5,
    viewBox: "0 0 19.1 20.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "folder-search") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "folder-search"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.9,21C4,21,2.8,19.8,2.8,15.9V7C2.8,3,4,1.8,7.9,1.8H9.2a2.87,2.87,0,0,1,2.7,1.3L13.2,5c.3.4.3.4.9.4h2.7c3.9,0,5.1,1.2,5.1,5.1v1.8a.7.7,0,0,1-1.4,0V10.5c0-3.2-.6-3.8-3.8-3.8H14a2.21,2.21,0,0,1-2-1L10.8,4a1.54,1.54,0,0,0-1.6-.8H7.9c-3.2,0-3.8.6-3.8,3.8v8.9c0,3.2.6,3.8,3.8,3.8H9.7a.68.68,0,0,1,.7.7.66.66,0,0,1-.7.6Z",
    transform: "translate(-2.8 -1.8)",
    fill: "{props.color}"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Capa_106",
    "data-name": "Capa 106"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M10.8,16.6a4.6,4.6,0,1,1,4.6,4.6A4.65,4.65,0,0,1,10.8,16.6Zm.7,0a3.9,3.9,0,0,0,3.9,3.9,3.9,3.9,0,0,0,0-7.8A3.9,3.9,0,0,0,11.5,16.6Z",
    transform: "translate(-2.8 -1.8)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.6,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4,21.9l-.9-.9a.35.35,0,0,1,.5-.5l.9.9a.45.45,0,0,1,0,.5c0,.1-.1.1-.2.1A.37.37,0,0,1,20.4,21.9Z",
    transform: "translate(-2.8 -1.8)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.6
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 0.9,
    y: 6,
    width: 17,
    height: 1,
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.1,
    cy: 3.8,
    r: 0.7,
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.91,6.72",
    transform: "translate(-2.8 -1.8)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderSearch);
export default __webpack_public_path__ + "static/media/folder-search.77bf602e2a15b5746645825df7ff5371.svg";
export { ForwardRef as ReactComponent };